import { useState, useEffect, useRef } from 'react';
import { AxiosInstance } from '../utils';
import { ToastContainer, toast } from 'react-toastify';

  function Contactus(eventInfo : any) {
     const [name, setName] = useState('');
     const [email, setEmail] = useState('');
     const [query, setQuery] = useState('');
     const onClickHandler = async (e)=>{

        e.preventDefault();
        let requestReq = {
            'name': name,
            'email': email,
            'query': query,
            'eventcode': eventInfo.eventcode
        };
        const { data: response } = await AxiosInstance.post('/api/contactus', requestReq, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.result == "Success") {
            toast.info("Success.");
            setName('');
            setEmail('');
            setQuery('');
        }
        else{
            toast.error("Failed.");
        }


     };
     return (<><section className="contact-sec sec-padding" data-scroll-index="9">
     <div className="container">
         <div className="sec-title">
             <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-ticket fa-stack-1x"></i></span></span>
             <h3 className="wow fadeInRight" data-wow-duration="500ms">Contact Us <small>/ Get in Touch</small></h3>
         </div> {/* <!--sec-title end--> */}
         <div className="contact-sec-details">
             <form className="js-ajax-form" onSubmit={onClickHandler}>
                 <div className="form-field">
                     <input type="text" name="name" placeholder="Type Your Name" required  value={name} onChange={(event) => {setName(event.target.value);}} />
                 </div> {/* <!--form-field end--> */}
                 <div className="form-field">
                     <input type="email" name="email" placeholder="Type Your Email" required  value={email} onChange={(event) => {setEmail(event.target.value);}} />
                 </div> {/* <!--form-field end--> */}
                 <div className="form-field">
                     <textarea name="message" placeholder="Type Your Message"  value={query} onChange={(event) => {setQuery(event.target.value);}} ></textarea>
                 </div> {/* <!--form-field end--> */}
                 <div className="form-field text-center">
                     <input type="submit" name="submit" value="Submit"  />
                 </div> {/* <!--form-field end--> */}
             </form>
         </div> {/* <!--contact-sec-details end--> */}
     </div>
 </section> </>);
    }

    export {Contactus}